import { getTabId } from "./tabId";

export const SIGNUP_MODAL_CONTEXT_SECOND_QUESTION_GATE = "second_question_gate";

const PENDING_SECOND_QUESTION_STORAGE_KEY = "incite:pending_second_question";

const sessionStorageOrNull = () => {
  if (typeof window === "undefined") return null;

  try {
    return window.sessionStorage;
  } catch (_error) {
    return null;
  }
};

export const questionLengthBucket = (question) => {
  const length = String(question || "").trim().length;
  if (length < 80) return "short";
  if (length < 220) return "medium";
  return "long";
};

export const writePendingSecondQuestion = ({
  question,
  threadUuid = null,
  currentSessionId = null,
  firstAnswerHadChart = false,
  firstAnswerFollowupClicked = false,
  conversionGate = null,
} = {}) => {
  const cleanedQuestion = String(question || "").trim();
  if (!cleanedQuestion) return null;

  const payload = {
    modal_context: SIGNUP_MODAL_CONTEXT_SECOND_QUESTION_GATE,
    question: cleanedQuestion,
    question_length_bucket: questionLengthBucket(cleanedQuestion),
    first_answer_had_chart: Boolean(firstAnswerHadChart),
    first_answer_followup_clicked: Boolean(firstAnswerFollowupClicked),
    conversion_gate: conversionGate,
    thread_uuid: threadUuid,
    tab_id: getTabId(),
    current_session_id: currentSessionId,
    created_at: new Date().toISOString(),
  };

  const storage = sessionStorageOrNull();
  if (!storage) return payload;

  try {
    storage.setItem(PENDING_SECOND_QUESTION_STORAGE_KEY, JSON.stringify(payload));
  } catch (_error) {
    return payload;
  }

  return payload;
};

export const readPendingSecondQuestion = () => {
  const storage = sessionStorageOrNull();
  if (!storage) return null;

  try {
    const raw = storage.getItem(PENDING_SECOND_QUESTION_STORAGE_KEY);
    if (!raw) return null;
    const parsed = JSON.parse(raw);
    if (!parsed?.question) return null;
    return parsed;
  } catch (_error) {
    return null;
  }
};

export const clearPendingSecondQuestion = () => {
  const storage = sessionStorageOrNull();
  if (!storage) return;

  try {
    storage.removeItem(PENDING_SECOND_QUESTION_STORAGE_KEY);
  } catch (_error) {
    return;
  }
};

export const pendingSecondQuestionEventMetadata = (extra = {}, pendingOverride = null) => {
  const pending = pendingOverride || readPendingSecondQuestion();
  if (!pending) return { ...extra };
  const conversionGate = pending.conversion_gate || {};

  return {
    modal_context: pending.modal_context || SIGNUP_MODAL_CONTEXT_SECOND_QUESTION_GATE,
    had_pending_question: true,
    question_length_bucket: pending.question_length_bucket || questionLengthBucket(pending.question),
    first_answer_had_chart: Boolean(pending.first_answer_had_chart),
    first_answer_followup_clicked: Boolean(pending.first_answer_followup_clicked),
    conversion_gate_assignment_id: conversionGate.assignment_id,
    conversion_gate_run_key: conversionGate.run_key,
    conversion_gate_variant_key: conversionGate.variant_key,
    conversion_gate_variant_label: conversionGate.variant_label,
    conversion_gate_stage: conversionGate.stage,
    conversion_gate_used_count: conversionGate.used_count,
    conversion_gate_limit_count: conversionGate.limit_count,
    conversion_gate_remaining_count: conversionGate.remaining_count,
    conversion_gate_pre_signup_answer_limit: conversionGate.pre_signup_answer_limit,
    conversion_gate_initial_post_signup_answer_limit: conversionGate.initial_post_signup_answer_limit,
    conversion_gate_recurring_free_daily_answer_allowance: conversionGate.recurring_free_daily_answer_allowance,
    ...extra,
  };
};
